module.exports = __webpack_public_path__ + "img/icon1.c5da4fe2.png";